module.exports = __webpack_public_path__ + "img/ic_32_workout_equipment.07efa43c.svg";